export const products = [
  {
    id: 1,
    slug: "essential-wellness",
    name: "Essential Wellness",
    image: "/MINDLEVER.jpg",
    shortDescription: "Reishi and Ginger Root blend for comprehensive immune and digestive wellness.",
    description: "Experience foundational wellness with our Essential Wellness Capsules. This simple yet powerful blend combines Reishi mushroom extract (Ganoderma lucidum), renowned for immune support and adaptogenic properties, with Ginger Root Powder for digestive health and anti-inflammatory benefits. A perfect daily supplement for overall vitality and balance.",
    dosage: "220mg per capsule",
    capsuleSize: "Size 1",
    price: "$54.99",
    benefits: [
      "Reishi mushroom for immune system support",
      "Anti-inflammatory and adaptogenic properties",
      "Ginger root for digestive health",
      "Supports overall wellness and balance",
      "Simple, clean formulation"
    ],
    ingredients: "Reishi Mushroom extract powder (Ganoderma lucidum) 100mg, Ginger Root Powder 120mg, vegetable cellulose (capsule)",
    usage: "Take 1-2 capsules daily with food, or as directed by your healthcare professional.",
    images: [
      "/MINDLEVER.jpg",
      "/MINDLEVER.jpg",
      "/MINDLEVER.jpg"
    ]
  },
  {
    id: 2,
    slug: "focus-blend",
    name: "Focus Blend",
    image: "/MINDLEVER3.jpg",
    shortDescription: "Gotu Kola, Lion's Mane, L-Theanine, and Cacao for mental clarity and cognitive support.",
    description: "Unlock your cognitive potential with our Premium Focus Blend. This expertly crafted formula combines Gotu Kola for mental clarity, Lion's Mane mushroom extract for neurological support, L-Theanine for calm focus, and Cacao for gentle mood elevation. A synergistic blend designed to enhance concentration and cognitive performance without stimulants.",
    dosage: "360mg per capsule",
    capsuleSize: "Size 0",
    price: "$54.99",
    benefits: [
      "Gotu Kola enhances mental clarity and alertness",
      "Lion's Mane supports nerve growth factor production",
      "L-Theanine promotes calm, focused attention",
      "Cacao provides natural mood support",
      "Natural nootropic blend with no stimulants"
    ],
    ingredients: "Gotu Kola (Centella asiatica) 50mg, Lion's Mane mushroom extract (Hericium erinaceus) 50mg, L-Theanine 100mg, Cacao 160mg, vegetable cellulose (capsule)",
    usage: "Take 1-2 capsules in the morning with breakfast for optimal cognitive support.",
    images: [
      "/MINDLEVER3.jpg",
      "/MINDLEVER3.jpg",
      "/MINDLEVER3.jpg"
    ]
  },
  {
    id: 3,
    slug: "energy-complex",
    name: "Energy Complex",
    image: "/MINDLEVER2.jpg",
    shortDescription: "Energizing blend of Cacao, Cordyceps, and Rhodiola for sustained vitality.",
    description: "Feel energized and ready to take on your day with our Energy Complex. This powerful formulation combines organic Cacao for gentle stimulation, Cordyceps mushroom extract for enhanced ATP production and oxygen utilization, and Rhodiola Rosea for adaptogenic stamina support. Together, these natural ingredients deliver sustained energy and resilience without any crash.",
    dosage: "350mg per capsule, 25 capsules per bottle",
    capsuleSize: "Size 00",
    price: "$54.99",
    benefits: [
      "Cordyceps increases ATP production and endurance",
      "Rhodiola reduces fatigue and enhances stamina",
      "Cacao provides natural energy and mood support",
      "Adaptogenic support for stress resilience",
      "No artificial stimulants or caffeine crash"
    ],
    ingredients: "Organic Cacao (Theobroma cacao) 150mg, Organic Cordyceps (Cordyceps militaris/sinensis) 100mg, Organic Rhodiola Rosea 100mg, vegetable cellulose (capsule)",
    usage: "Take 1 capsule in the morning and 1 in the early afternoon with meals.",
    images: [
      "/MINDLEVER2.jpg",
      "/MINDLEVER2.jpg",
      "/MINDLEVER2.jpg"
    ]
  },
  {
    id: 4,
    slug: "neurogenesis",
    name: "Neurogenesis",
    image: "/MINDLEVER4.jpg",
    shortDescription: "Gotu Kola, Lion's Mane, and Niacin for neuroplasticity and cognitive enhancement.",
    description: "Optimize your brain's natural regenerative capacity with our Neurogenesis formula. This specialized blend features Gotu Kola for enhanced neuroplasticity, Lion's Mane mushroom extract to promote nerve growth factor production, and Niacin for cerebral blood flow support. Together, these ingredients support brain health, memory formation, and cognitive processing.",
    dosage: "390mg per capsule",
    capsuleSize: "Size 0",
    price: "$54.99",
    benefits: [
      "Gotu Kola promotes nerve growth and neuroplasticity",
      "Lion's Mane supports neuronal health and NGF production",
      "Niacin enhances cerebral circulation",
      "Supports memory formation and cognitive function",
      "Natural brain regeneration support"
    ],
    ingredients: "Gotu Kola (Centella asiatica) 100mg, Lion's Mane mushroom extract 250mg, Niacin 40mg, vegetable cellulose (capsule)",
    usage: "Take 1-2 capsules daily with food for optimal neurological support.",
    images: [
      "/MINDLEVER4.jpg",
      "/MINDLEVER4.jpg",
      "/MINDLEVER4.jpg"
    ]
  }
];